module.exports = __webpack_public_path__ + "static/media/bookmark-select.704198b5.svg";